export default __webpack_public_path__ + "img/paste.abff370e.svg";